import { SchedulingType } from "../enums/taskType";
import { Scheduling } from "../models/schedule";
import { AssetDto } from "./assetDto";
import { dealershipDto } from "./dealershipDto";
import { driverDto } from "./driverDto";
import { AssetSchedulingDto } from "./assetDto";

export const SchedulingDto = (data: any): Scheduling => {
  const result = {
    id: data.id,
    scheduleNumber: data.scheduleNumber,
    checkup: {
      id: data.checkup?.id,
      name: data?.checkup ? `Revisão de ${data.checkup.range?.start.toLocaleString("pt-Br")} km` : `Revisão realizada com ${data.schedule?.odometer.toLocaleString("pt-Br")} km`,
      description: data?.checkup ? `Revisão de ${data.checkup.range?.start.toLocaleString("pt-Br")} km` : `Revisão realizada com ${data.schedule?.odometer.toLocaleString("pt-Br")} km`,
      odometer: data.checkup?.range?.start,
      hourmeter: null,
      services: (data.checkup?.checkupType?.services ?? []).map((service: any) => ({
        name: service.name,
        items: service.items,
      })),
      aditionalServices: (data.checkup?.aditionalServices ?? []).map((service: any) => ({
        id: service.id,
        name: service.name,
        price: service.price,
      })),
      parts: data.checkup?.parts,
      type: SchedulingType.PREVENTIVA,
    },
    asset: AssetDto(data.vehicleSchedule),
    driver: driverDto(data.vehicleSchedule?.driver),
    observation: data.vehicleSchedule?.generalObservations,
    comments: data.vehicleSchedule?.comments,
    consultant: `${data.consultant?.firstName ?? ""} ${
      data.consultant?.lastName ?? ""
    }`,
    dealership: dealershipDto(data.vehicleSchedule?.dealership),
    date: new Date(data.schedule?.scheduledDate),
    otherServices: (data.vehicleSchedule?.otherServices?.services ?? []).map(
      (service: any) => service.name
    ),
    totalPrice: data.vehicleSchedule?.otherServices?.total ?? 0,
    campaigns: data.campaigns,
    scheduledBy: data.scheduledBy,
    maintenanceStatus: data.vehicleSchedule?.maintenance?.statusId,
  };
  
  return result;
};

export const getAssetSchedulings = (nextCheckups: any[], previousCheckups: any[]) => {
  if(nextCheckups.length === 0 || previousCheckups.length === 0) return {
    previous: [],
    next: [],
  };

  const interval = nextCheckups[1]?.odometer - nextCheckups[0]?.checkup?.range?.start;

  return {
    previous: previousCheckups
      ?.map((data) => AssetSchedulingDto({ 
        ...data, 
        isFinished: true,
        checkup: {
          ...data.checkup,
          range: {
            start: data.checkup.range?.start || (data.schedule?.odometer ? Math.floor(data.schedule?.odometer / interval) * interval : null),
            end: data.checkup.range?.start + interval,
          },
        }
      })),
    next: nextCheckups
      ?.map((data) => AssetSchedulingDto({ 
        ...data, 
        isFinished: false,
        checkup: {
          ...data.checkup,
          range: {
            start: data.checkup.range?.start,
            end: data.checkup.range?.start + interval,
          },
        }
      })),
  }
}